export function SectionAgentesDetails () {
  return (
    <section className="section section-bancos-details">
      <div className="container">
        <aside>
          <img src="img/bancos/aside.png" className="consideraciones-img" />
        </aside>
        <article>
          <h2 className="title">Comisión</h2>
          <p className="bancos-details__subtitle">Acércate a un agente BCP y pide hacer un giro nacional. </p>
          <h2 className="title">Consideraciones</h2>
          <div className="consideraciones-wraper">
            <div>
              <h3 className="consideraciones-title">
                <img src="img/bancos/limites-pagos.png" alt="" />
                Límites de pago
              </h3>
              <ul className="consideraciones-list">
                <li>
                  <p>Las transacciones se pueden realizar en efectivo, con tarjeta de debito y tarjeta de crédito dependiendo del tipo de operación.</p>
                </li>
                <li>
                  <p>Brinda todos los datos: ordenante, solicitante, beneficiario y monto.</p>
                </li>
                <li>
                  <p>¡Listo! Pide tu voucher y ya tienes el giro realizado.</p>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="consideraciones-title">
                <img src="img/bancos/otros.png" alt="" />
                Otros
              </h3>
              <ul className="consideraciones-list">
                
              </ul>
            </div>
          </div>
        </article>
      </div>
    </section>
  )
}